<template>
  <div class="submenu-cont">
    <div class="submenu-item green"
        v-if="adminRole"
        @click="addUser">
      {{$t('menu.sidebar.invite')}}
      <plus-icon :fill="'#39B54A'"></plus-icon>
    </div>
    <router-link v-if="adminRole"
                 :to="'/users'"
                 class="submenu-item">
      {{$t('menu.sidebar.userList')}}
      <list-icon :fill="'rgba(0, 82, 127, .4)'"></list-icon>
    </router-link>
    <router-link v-if="adminRole"
                 :to="'/assigned-roles'"
                 class="submenu-item big-item">
      {{ $t('roles.rolesList') }}
      <groupIcon :fill="'rgba(0, 82, 127, .4)'" />
    </router-link>

    <router-link  :to="'/profile'" class="submenu-item">
      {{$t('menu.sidebar.editProfile')}}
      <svg class="gear-icon-main" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="gear-icon-first-circle" d="M6.52347 14.0897L6.48012 13.7776L6.17983 13.682C5.82824 13.5702 5.49339 13.4266 5.17473 13.2514L4.89108 13.0953L4.63265 13.2903L3.64241 14.0373L3.6424 14.0373L3.63868 14.0402C3.61921 14.0551 3.60042 14.0607 3.57836 14.0603C3.55671 14.06 3.52749 14.0533 3.49598 14.0349L3.49064 14.0304L3.43293 13.9828C3.38573 13.9438 3.32048 13.8896 3.24269 13.8234C3.08755 13.6913 2.88422 13.5129 2.67783 13.3149L2.61202 13.2491L2.61197 13.249C2.40826 13.0453 2.23163 12.8442 2.10313 12.6908C2.03913 12.6144 1.98748 12.5504 1.95058 12.5041L1.90541 12.4473L1.88839 12.4261L1.88584 12.423C1.86816 12.3978 1.86373 12.3763 1.86373 12.3605C1.86373 12.3434 1.86889 12.3197 1.89034 12.2918L1.89035 12.2918L1.89236 12.2892L2.65676 11.2816L2.85299 11.0229L2.69652 10.7384C2.52905 10.4339 2.40171 10.0884 2.2832 9.71592L2.18806 9.41692L1.87745 9.37255L0.661377 9.19883L0.661388 9.19875L0.652685 9.19766C0.621829 9.19381 0.57728 9.16578 0.566541 9.0996L0.56619 9.09586L0.563611 9.07148L0.555935 8.99969C0.549699 8.93993 0.541395 8.85585 0.533089 8.75411C0.516405 8.54974 0.5 8.27746 0.5 7.99132V7.90445C0.5 7.61849 0.516385 7.3507 0.533055 7.14859C0.541359 7.0479 0.549677 6.96416 0.556004 6.90274L0.563964 6.82592C0.563985 6.82571 0.564028 6.8253 0.564091 6.82472C0.564513 6.82081 0.565804 6.80884 0.567018 6.79365C0.571723 6.76881 0.582394 6.7504 0.596561 6.7359C0.612023 6.72007 0.637141 6.70362 0.674564 6.69509L1.91026 6.52347L2.22239 6.48012L2.31794 6.17983C2.4298 5.82825 2.57338 5.4934 2.74865 5.17473L2.90466 4.89109L2.7097 4.63265L1.96268 3.64241L1.96269 3.6424L1.95983 3.63868C1.94486 3.61921 1.9393 3.60042 1.93967 3.57836C1.94003 3.55671 1.94671 3.52749 1.96514 3.49598L1.96959 3.49065L2.01718 3.43294C2.05616 3.38574 2.11036 3.32049 2.17659 3.2427C2.30867 3.08755 2.48716 2.88421 2.68511 2.67782L2.75096 2.61197L2.3974 2.25842L2.75096 2.61197C2.95466 2.40826 3.15581 2.23163 3.30918 2.10313C3.38556 2.03913 3.44961 1.98748 3.49586 1.95058L3.55271 1.90541L3.57393 1.88839L3.577 1.88584C3.60223 1.86815 3.62372 1.86373 3.63953 1.86373C3.65659 1.86373 3.68029 1.86889 3.70817 1.89034L3.70816 1.89035L3.71083 1.89237L4.71844 2.65676L4.97711 2.85299L5.2616 2.69652C5.5661 2.52905 5.91162 2.40171 6.28408 2.2832L6.58308 2.18806L6.62745 1.87745L6.80117 0.661377L6.80125 0.661388L6.80234 0.652685C6.80619 0.621852 6.83422 0.577283 6.90042 0.566541L6.90416 0.56619L6.92855 0.563611L7.00033 0.555935C7.06008 0.549699 7.14416 0.541395 7.2459 0.533089C7.45027 0.516405 7.72254 0.5 8.00868 0.5H8.09555C8.38151 0.5 8.64931 0.516385 8.85141 0.533055C8.9521 0.541359 9.03584 0.549677 9.09726 0.556004L9.17408 0.563964C9.17429 0.563985 9.1747 0.564028 9.17528 0.564091C9.17919 0.564513 9.19116 0.565804 9.20635 0.567018C9.23119 0.571723 9.2496 0.582394 9.2641 0.596561C9.27993 0.612023 9.29638 0.637141 9.30491 0.674564L9.47653 1.91026L9.51988 2.22239L9.82018 2.31794C10.1718 2.42981 10.5066 2.57337 10.8253 2.74863L11.1089 2.90463L11.3673 2.70968L12.3576 1.96268L12.3576 1.9627L12.3613 1.95983C12.3808 1.94486 12.3996 1.9393 12.4216 1.93967C12.4433 1.94003 12.4725 1.94671 12.504 1.96514L12.5094 1.96959L12.5671 2.01718C12.6143 2.05616 12.6795 2.11036 12.7573 2.17659C12.9125 2.30868 13.1158 2.48718 13.3222 2.68514L13.388 2.75094C13.388 2.75095 13.3881 2.75097 13.3881 2.75099C13.5918 2.95468 13.7684 3.1558 13.8969 3.30916C13.9609 3.38554 14.0125 3.44959 14.0494 3.49584L14.0946 3.55269L14.1116 3.57391L14.1142 3.57698C14.1318 3.60221 14.1363 3.6237 14.1363 3.63951C14.1363 3.65659 14.1311 3.68029 14.1097 3.70817L14.1076 3.71083L13.3432 4.71844L13.147 4.97711L13.3035 5.2616C13.471 5.5661 13.5983 5.9116 13.7168 6.28406L13.8119 6.58305L14.1226 6.62743L15.3386 6.80115L15.3386 6.80123L15.3473 6.80232C15.3781 6.80617 15.4227 6.8342 15.4335 6.90042L15.4338 6.90416L15.4364 6.92855L15.4441 7.00033C15.4503 7.06008 15.4586 7.14416 15.4669 7.2459C15.4836 7.45027 15.5 7.72254 15.5 8.00868V8.09555C15.5 8.38151 15.4836 8.6493 15.4669 8.8514C15.4586 8.95208 15.4503 9.03582 15.444 9.09724L15.436 9.17406L15.4359 9.17525C15.4355 9.17917 15.4342 9.19114 15.433 9.20633C15.4283 9.23118 15.4176 9.24959 15.4034 9.2641C15.388 9.27993 15.3628 9.29638 15.3254 9.30491L14.0897 9.47653L13.7776 9.51988L13.6821 9.82017C13.5702 10.1718 13.4266 10.5066 13.2514 10.8253L13.0954 11.1089L13.2903 11.3674L14.0373 12.3576L14.0373 12.3576L14.0402 12.3613C14.0551 12.3808 14.0607 12.3996 14.0603 12.4216C14.06 12.4433 14.0533 12.4725 14.0349 12.504L14.0304 12.5094L13.9828 12.5671C13.9438 12.6143 13.8896 12.6795 13.8234 12.7573C13.6913 12.9125 13.5128 13.1158 13.3149 13.3222L13.2491 13.388C13.0454 13.5917 12.8442 13.7684 12.6909 13.8969C12.6145 13.9609 12.5504 14.0125 12.5042 14.0494L12.4473 14.0946L12.4261 14.1116L12.423 14.1141C12.3978 14.1318 12.3763 14.1362 12.3605 14.1362C12.3434 14.1362 12.3197 14.1311 12.2918 14.1096L12.2892 14.1076L11.2816 13.3432L11.0229 13.147L10.7384 13.3035C10.4339 13.471 10.0884 13.5983 9.71594 13.7168L9.41694 13.812L9.37257 14.1226L9.19885 15.3386L9.19877 15.3386L9.19768 15.3473C9.19389 15.3777 9.16665 15.4214 9.10259 15.433C9.08491 15.4344 9.07149 15.4359 9.06985 15.4361L8.99302 15.444C8.9316 15.4503 8.84787 15.4587 8.74718 15.467C8.54508 15.4836 8.27729 15.5 7.99132 15.5H7.90445C7.61848 15.5 7.35069 15.4836 7.14859 15.467C7.0479 15.4587 6.96417 15.4503 6.90275 15.444L6.82592 15.4361L6.82475 15.4359C6.82085 15.4355 6.80888 15.4342 6.79367 15.433C6.76882 15.4283 6.75041 15.4176 6.7359 15.4035C6.72007 15.388 6.70362 15.3629 6.6951 15.3255L6.52347 14.0897Z" stroke="#109CF1" fill="none"/>
        <path class="gear-icon-inner-circle" d="M8 4.5C6.07631 4.5 4.5 6.07631 4.5 8C4.5 9.92369 6.07631 11.5 8 11.5C9.92369 11.5 11.5 9.92369 11.5 8C11.5 6.07631 9.92369 4.5 8 4.5Z" stroke="#109CF1" fill="none"/>
      </svg>
    </router-link>
    <div @click="logout" class="submenu-item">
      {{$t('menu.logout')}}
      <logout-icon :fill="'rgba(0, 82, 127, .4)'"></logout-icon>
    </div>
  </div>
</template>

<script>
  import {mapGetters,mapMutations, mapActions} from 'vuex'
  import {showOverlay} from "../../mixins/utils/showOverlay"
  import plusIcon from '../Svg/plusIcon'
  import listIcon from '../Svg/sidebar/listIcon'
  import logoutIcon from '../Svg/sidebar/logout'
  import groupIcon from '../Svg/cart_control/groupIcon'


  export default {
    name: 'submenu',
    mixins: [showOverlay],
    components: {
      plusIcon,
      listIcon,
      logoutIcon,
      groupIcon
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole'
      })
    },
    methods: {
      ...mapMutations({
        showAddUserPopup: 'popups/addUser/SET_SHOW',
      }),
      ...mapActions({
        logout: 'auth/logout'
      }),
      addUser() {
        this.showOverlay(true);
        this.showAddUserPopup(true);
      }
    },
  }
</script>

<style lang="scss" scoped>
  .submenu-cont {
    position: absolute;
    top: 58px;
    right: -30px;
    background: white;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;
    padding: 30px 20px 0px!important;

    &::before {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 5px 6px 5px;
      border-color: transparent transparent white transparent;
      position: absolute;
      bottom: 100%;
      right: 48px;
    }

    .submenu-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      white-space: nowrap;
      padding: 0 10px;
      margin-bottom: 20px;
      font-family: $msb;
      font-size: 12px;
      letter-spacing: .15px;
      color: $darkBlue;
      cursor: pointer;

      svg {
        margin-left: 15px;
      }

      &.green {
        color: $green;

        svg {
          width: 10px;
        }
      }

      &.big-item {
        padding-bottom: 20px;
        border-bottom: 1px solid $grey;
      }
    }
  }

  .gear-icon-main {
    .gear-icon-first-circle {
      stroke: rgba(0, 82, 127, .4) !important;
    }
    .gear-icon-inner-circle {
      stroke: rgba(0, 82, 127, .4) !important;
    }
  }
  .gear-icon-main:hover {
    .gear-icon-first-circle {
      fill: none!important;
    }
    .gear-icon-inner-circle {
      fill: none!important;
    }
  }
</style>
